// 工具接口
import { get, post } from '@/api/base/request';
import { apiPrefix } from '@/api/url';

const {baseApi, fixBaseTestApi, aiApi} = apiPrefix;

// AI音频验证 - 列表
export const getAiAudioValidateList = (params) => post(baseApi + '/callRecordingAnnotation/annotationList', params);
// AI音频验证 - 保存
export const aiAudioValidateUpdate = (params) => post(baseApi + "/callRecordingAnnotation/update/annotation", params);
// AI音频验证 - select
export const aiAudioValidateSelect = (params) => post(baseApi + "/callRecordingAnnotation/operateRecord", params);



// 剧本ID - 选项
// export const getLinkScriptIdOption = (params) => get(`${baseApi}/fsRecordMark/getLinkScriptList`, params);
export const getLinkScriptOptions = (params={}) => {
  const {isPostTest, ...restParams} = params;
  if (isPostTest) return get(`${apiPrefix.fixAiTestApi}/test/queryScriptList`, restParams);
  return get(`${aiApi}/test/queryScriptList`, restParams);
}
// 剧本节点 - 选项
export const getLinkScriptNodeOptions = (params) => get(`${aiApi}/test/queryScriptNode`, params);
// 命中策略选择 - 选项
export const getStrateOptions = (params) => get(`${baseApi}/fsRecordMark/getStrategyList`, params);
// 对话节点 - 选项
export const getConversationNodeOptions = (params) => get(`${baseApi}/fsRecordMark/getNodeList`, params);
// 标记师 - 选项列表
export const getMarkUserOptions = (params) => get(`${baseApi}/fsRecordMark/getMarkUserList`, params);
// 标记师 - 选项列表(新接口，带userId)
export const getNewMarkUserOptions = (params={}) => {
  const {isPostTest, ...restParams} = params;
  if (isPostTest) return get(`${fixBaseTestApi}/fsRecordMarkNew/getMarkUserList`, restParams);
  return get(`${baseApi}/fsRecordMarkNew/getMarkUserList`, restParams);
}


// 录音下发数量查询 
export const voiceAssignCountQuery = (params) => post(`${baseApi}/fsRecordMarkNew/getCanBeIssuedNum`, params);
// 录音下发
export const voiceAssign = (params) => post(`${baseApi}/fsRecordMarkNew/issued`, params);




// 标记台 - 通话标记 - 列表
// export const getAcmCallList = (params) => post(`${baseApi}/fsRecordMark/markObserveNew`, params);
export const getAcmCallList = (params) => post(`${baseApi}/fsRecordMarkNew/getMarkList`, params);
// 标记台 - 通话标记 - 详情
export const getAcmCallDetail = (params = {}) => {
  const {isPostTest, ...restParams} = params;
  if (isPostTest) return get(`${fixBaseTestApi}/fsRecordMarkNew/getMarkInfo`, restParams);
  return get(`${baseApi}/fsRecordMarkNew/getMarkInfo`, restParams);
}
// 标记台 - 通话标记 - 意图标记
export const acmCallChatIntentionMark = (params) => {
  const {isPostTest, ...restParams} = params;
  if (isPostTest) return post(`${fixBaseTestApi}/fsRecordMarkNew/submitMarkInfo`, restParams);
  return post(`${baseApi}/fsRecordMarkNew/submitMarkInfo`, restParams);
}
// 标记台 - 通话标记 - 更新
export const acmCallUpdate= (params) => {
  const {isPostTest, ...restParams} = params;
  if (isPostTest) return post(`${fixBaseTestApi}/fsRecordMarkNew/updateWholeCall`, restParams);
  return post(`${baseApi}/fsRecordMarkNew/updateWholeCall`, restParams, {noValid: true});
}


// 标记台 - 对话标记 - 获取通话标记概览
export const getAcmOverview = (params) => get(`${baseApi}/fsRecordMark/getFsMarkNum`, params);
// 标记台 - 对话标记 - 获取通话标记详情
export const getAcmDetail = (params) => post(`${baseApi}/fsRecordMark/getFsRecortMarkInfo`, params);
// 标记台 - 对话标记 - 标记提交
export const acmSubmit = (params) => post(`${baseApi}/fsRecordMark/submitMarkInfo`, params);


// 标记通话记录 - 列表
export const getAmcrList = (params) => post(`${baseApi}/fsRecordMark/callRecordObserveNew`, params);
// 标记通话记录 - 导出
export const amcrExport = (params) => post(`${baseApi}/fsRecordMark/callRecordObserveNew`, params, {responseType: "blob"});
// 标记通话记录 - 详情
// 标记通话记录 - 详情 ——「看对话」的对话正文
//   🔴 2026-10-09 新增 `source` 入参（数据来源切换，两种口径**不等价**）：
//     · 不传        = 默认口径：有智保云实时结果就用它，否则逐轮 → 回捞兜底（改造前的行为）
//     · 'online'    = 只要线上识别（逐轮识别表，带节点/意图/标注/轮次音频/转人时刻；空则回捞兜底），
//                     后端完全不查实时 ASR
//     · 'wc'        = 只要 wisdom-cloud 实时 ASR（列表行「识别」按钮对整通录音的转写，按段落拆分）；
//                     该通没有时返回**空数组**，🔴 不回落逐轮 —— 回落会让切换按钮变成"点了没反应"
//   出参始终是数组（无数据时为空数组，不是 error），行上的 `dataSource` 标注实际来源：
//     逐轮行无标记 / '回捞ASR' / '实时ASR'。
export const getAmcrDetail = (params) => get(`${baseApi}/fsRecordMark/getCallRecordDetail`, params);
// 标记通话记录 - 触发实时ASR识别（异步，落库后轮询）
// 迁移后：智保云内置 ASR 引擎，路径收敛到 /call/asr；入参升级为 bizType+bizId（电话域=callId）
// 方案 A：recordingUrl 由前端把行内录音地址直传后端（域名白名单校验后下载），为空则后端回退按 bizId 反查；
// 企微域（bizType=2）显式传 bizType/bizId（bizId=企微消息 id）。
export const asrRecognize = (params = {}) => post(`${baseApi}/call/asr/recognize`, {
  bizType: params.bizType != null ? params.bizType : 1,
  bizId: params.bizId != null ? params.bizId : params.callId,
  recordingUrl: params.recordingUrl,
});
// 标记通话记录 - 查询实时ASR识别结果（轮询）
export const getAsrResult = (params = {}) => get(`${baseApi}/call/asr/result`, {
  bizType: params.bizType != null ? params.bizType : 1,
  bizId: params.bizId != null ? params.bizId : params.callId,
});


// 观察台 - 通话标记 - 列表
export const getAcmlCallList = (params) => post(`${baseApi}/fsRecordMarkNew/getSubmitMarkList`, params);
// 观察台 - 通话标记 - 导出
export const acmlCallExport = (params) => post(`${baseApi}/fsRecordMarkNew/getSubmitMarkList`, params, {responseType: "blob"});

// 观察台 - 对话标记 - 列表
export const getAcmlList = (params) => post(`${baseApi}/fsRecordMark/markObserveNew`, params);
// 观察台 - 对话标记 - 导出
export const acmlExport = (params) => post(`${baseApi}/fsRecordMark/markObserveNew`, params, {responseType: "blob"});





// FAQ维护台 - 上传
export const faqUpload = (params) => {
  const data = new FormData();
  Object.keys(params).forEach((item) => {
    data.append(item, params[item]);
  });
  return post(`${aiApi}/faqimport/putExcel`, data, {
    headers: {"Contennt-Type": "multipart/form-data",},
    noValid: true,
  });
}



// 批量保存音频（根据文本列表）
export const audioSave = (params) => post(`${baseApi}/audio/save`, params);
// 多条件查询音频列表
export const getAudioList = (params) => post(`${baseApi}/audio/list`, params);
// 删除音频
export const deleteAudio = (params) => get(`${baseApi}/audio/deleteAudio`, params);




// 测试台 - 通话测试 - AI通话启动
export const startAiCallTest = (params) => post(`${fixBaseTestApi}/fsRecordMarkNew/submitAiCallTest`, params);
// 测试台 - 通话测试 - AI通话启动状态查询
export const queryAiCallTestStatus = (params) => get(`${fixBaseTestApi}/fsRecordMarkNew/getAiCallProcess`, params);
// 测试台 - 通话测试 - 详情
export const getAiTestCallDetail = (params) => get(`${fixBaseTestApi}/fsRecordMarkNew/getMarkInfo`, params);
// 测试台 - 通话测试记录 - 列表
export const getAiCallTestRecordList = (params) => get(`${fixBaseTestApi}/fsRecordMarkNew/getAiCallTestList`, params);



// 测试台 - 文本测试 - 测试提交
export const aiTestSubmit = (params) => post(`${aiApi}/test/batchRecognize`, params);
// 测试台 - 文本测试 - 测试结果下载
export const aiTestResultExport = (params) => {
  return get(baseApi + "/test/downloadRecognizeResult", params, {responseType: "blob"});
}



// 策略迭代 - 列表
export const getAsiList = (params) => post(`${baseApi}/jobOrder/queryCallRecord`, params);


// 数据统计 - 标记分析 - 统计
export const getAvmsIntentionMarkResult = (params) => {
  return post(`${baseApi}/fsRecordMarkNew/getDataBoardList`, params);
}
// 意图判断准确率、语音转文字准确率 - 统计
export const getIntentionStats = (params) => {
  return post(`${baseApi}/fsRecordMark/fsRecordMarkReport`, params);
}

// 数据统计 - 优化反馈 - 筛选项
export const getAvmsFeedbackFilterOptions = (params) => {
  return post(`${baseApi}/shenduOptimizeFeedback/getOptions`, params);
}
// 数据统计 - 优化反馈 - 列表
export const getAvmsFeedbackList = (params) => {
  // params.beginDate = '2026-02-15';
  // params.endDate = '2026-02-15';
  // params.page = 1;
  // params.size = 10;
  return post(`${baseApi}/shenduOptimizeFeedback/getList`, params);
}
// 数据统计 - 优化反馈 - 下载当前页
export const exportAvmsFeedbackList = (params) => {
  params.downLoad = true;
  return post(`${baseApi}/shenduOptimizeFeedback/getList`, params, {responseType: "blob"});
}
